// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__O44Sx","titleContainer":"Projects_titleContainer__p5JsP","title":"Projects_title__IH2+s","intro-gradient":"Projects_intro-gradient__0Oy+B"};